import { FC } from 'react'
import { TopToolbar, useRecordContext, useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Button } from '@mui/material'

interface BackToOrgActionsProps {
  tabPath: string
  orgIdField?: string
}

export const BackToOrgActions: FC<BackToOrgActionsProps> = ({ tabPath, orgIdField = 'organization_id' }) => {
  const record = useRecordContext<Record<string, unknown>>()
  const navigate = useNavigate()
  const translate = useTranslate()
  // eslint-disable-next-line security/detect-object-injection
  const orgId = record?.[orgIdField] as string | undefined

  return (
    <TopToolbar>
      <Button
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(orgId ? `/organization/${orgId}/show/${tabPath}` : '/organization')}
        sx={{ gap: 0.5, textTransform: 'none' }}
      >
        {translate('ra.action.back')}
      </Button>
    </TopToolbar>
  )
}
